import styled, { css } from 'styled-components'

type CaseConclusionProps = {
  underlineColor?: string
  elementVisible: boolean
}

export const CaseConclusionContainer = styled.div<CaseConclusionProps>`
  display: flex;
  width: 100%;
  max-width: 1170px;

  align-items: center;

  flex-direction: column;
  gap: 112px;

  .title {
    width: 50%;
    z-index: 1;

    color: ${(props) => props.theme.colors.black};
    margin-bottom: 12px;

    position: relative;

    .bar {
      width: 0;
      max-width: 543px;
      border: 2px solid
        ${(props) => props.underlineColor || props.theme.colors.primary};
      position: absolute;
      left: 0;
      bottom: 0.6rem;
      transition: width 0.8s ease-in;
      z-index: -1;

      ${({ elementVisible }) =>
        elementVisible &&
        css`
          width: 100%;
        `}
    }

    @media (max-width: 768px) {
      width: 100%;
      .bar {
        bottom: 0;
      }
    }
  }
`
export const CurrentCaseContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 112px;
`

export const CardContainer = styled.div`
  margin-top: 80px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
  gap: 10%;
  @media (max-width: 1200px) {
    gap: 4%;
  }
  @media (max-width: 768px) {
    gap: 8px;
    flex-direction: column;
  }
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  gap: 80px;

  .description {
    color: ${(props) => props.theme.colors.black};
    width: 100%;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`

export const NextCaseContainer = styled.div`
  width: 100%;
  height: max-content;
  position: relative;
  transition: all 0.3s ease-in-out;
  cursor: pointer;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0px 16px 16px rgba(38, 38, 54, 0.26),
      0px 24px 32px rgba(36, 36, 49, 0.253);
  }

  @media (max-width: 1180px) {
    &:hover {
      transform: scale(1.02);
    }
  }
`

export const FilterContainer = styled.div`
  width: 100%;
  height: max-content;
  position: relative;
`

export const NextCaseData = styled.div`
  width: 100%;
  padding: 16px 10.33px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 26px;

  img {
    width: auto;
    height: auto;
    max-height: 40%;
  }

  @media (min-width: 920px) {
    padding: 42px 139px;
  }

  @media (max-width: 768px) {
    padding: 16px;

    .next-case:hover {
      transform: scale(1.1);
    }
  }
`
